<template>
  <div id="home">
    <!-- <div class="hero-bg">
      <div class="hero">
        <div class="hero-title">
          精准发音，全球对话<br />
          <span class="blue">晓A精灵，你的AI英语专家</span>
        </div>
        <div class="hero-desc">
          0.5秒全维学习诊断，动态难度系统智能适配学习节奏，500+国际场景训练培养全球胜<br />任力。发音要准，进步要狠，未来要稳！
        </div>
      </div>
    </div> -->
     <!-- :autoplay="false" -->
    <el-carousel class="h-el-carousel">
      <el-carousel-item v-for="item in 3" :key="item">
        <img
          class="h-el-carousel-img"
          :src="require(`../assets/new-page/hone/bannar${item}.png`)"
          alt=""
        />
      </el-carousel-item>
    </el-carousel>
    <div class="stats-section">
      <div class="stats-title-small">学习资源</div>
      <div class="stats-title">海量学习内容，智能匹配需求</div>
      <div class="stats-cards">
        <div class="stat-card">
          <div class="icon icon1"></div>
          <div class="stat-card-title">知识点词库量</div>
          <div class="stat-card-value">10,000+</div>
        </div>
        <div class="stat-card">
          <div class="icon icon2"></div>
          <div class="stat-card-title">专项练习题</div>
          <div class="stat-card-value">100万+</div>
        </div>
        <div class="stat-card">
          <div class="icon icon3"></div>
          <div class="stat-card-title">智能模拟试题</div>
          <div class="stat-card-value">50,000+</div>
        </div>
        <div class="stat-card">
          <div class="icon icon4"></div>
          <div class="stat-card-title">国际化场景</div>
          <div class="stat-card-value">500+</div>
        </div>
      </div>
    </div>
    <!-- <div class="section-title-small">教育优势</div>
    <div class="section-title">为什么选择AI英语学习</div>
    <div class="compare-cards">
      <div class="compare-card">
        <div class="compare-card-title">传统线下培训</div>
        <ul>
          <li><i class="el-icon-close"></i> 师资水平不均，难以个性化</li>
          <li><i class="el-icon-close"></i> 个体问题响应时间过久</li>
          <li><i class="el-icon-close"></i> 运营成本占比高达75%</li>
        </ul>
      </div>
      <div class="compare-card">
        <div class="compare-card-title">传统线上培训</div>
        <ul>
          <li><i class="el-icon-close"></i> 缺乏有效互动机制</li>
          <li><i class="el-icon-close"></i> 课程完成率低于30%</li>
          <li><i class="el-icon-close"></i> 知识留存率不足25%</li>
        </ul>
      </div>
      <div class="compare-card">
        <div class="compare-card-title">一对一教学</div>
        <ul>
          <li><i class="el-icon-close"></i> 优质师资严重短缺</li>
          <li><i class="el-icon-close"></i> 人力成本高达8倍</li>
          <li><i class="el-icon-close"></i> 扩张速度受限</li>
        </ul>
      </div>
    </div> -->
    <div class="ai-section">
      <div class="ai-info">
        <div class="ai-info-title">晓A精灵</div>
        <div class="ai-info-list">
          <div class="ai-info-list-item">
            <div class="ai-lable-img icon18"></div>
            <div class="txt-box">
              <div class="txt1">全球资源智能匹配</div>
              <div class="txt2">整合全球优质教育资源</div>
            </div>
          </div>
          <div class="ai-info-list-item">
            <div class="ai-lable-img icon19"></div>
            <div class="txt-box">
              <div class="txt1">国际国内课标适配</div>
              <div class="txt2">双向适配各类课程标准</div>
            </div>
          </div>
          <div class="ai-info-list-item">
            <div class="ai-lable-img icon20"></div>
            <div class="txt-box">
              <div class="txt1">实时场景对话训练</div>
              <div class="txt2">模拟真实国际交流场景</div>
            </div>
          </div>
          <div class="ai-info-list-item">
            <div class="ai-lable-img icon21"></div>
            <div class="txt-box">
              <div class="txt1">全维学习诊断</div>
              <div class="txt2">0.5秒快速分析学习问题</div>
            </div>
          </div>
        </div>
      </div>
      <div class="ai-img"></div>
    </div>
    <div class="features-section">
      <div class="features-title-small">提升逻辑</div>
      <div class="features-title">科学高效的学习路径</div>
      <div class="features-cards">
        <div class="feature-card">
          <div class="icon icon5"></div>
          <div class="feature-card-content">
            <div class="feature-card-title">智能学情双核诊断系统</div>
            <div class="feature-card-desc">
              基于算法与知识图谱生成三维学情画像
            </div>
          </div>
        </div>
        <div class="feature-card">
          <div class="icon icon6"></div>
          <div class="feature-card-content">
            <div class="feature-card-title">毫秒级弱点追踪技术</div>
            <div class="feature-card-desc">
              实时锁定发音、语法、跨文化交际三大薄弱点
            </div>
          </div>
        </div>
        <div class="feature-card">
          <div class="icon icon7"></div>
          <div class="feature-card-content">
            <div class="feature-card-title">自适应学习引擎</div>
            <div class="feature-card-desc">
              按考纲匹配最优内容，同步提升分数与能力
            </div>
          </div>
        </div>
        <div class="feature-card">
          <div class="icon icon8"></div>
          <div class="feature-card-content">
            <div class="feature-card-title">多维度细颗粒度训练</div>
            <div class="feature-card-desc">
              拆解知识点至最小单元，靶向攻克盲区
            </div>
          </div>
        </div>
        <div class="feature-card">
          <div class="icon icon9"></div>
          <div class="feature-card-content">
            <div class="feature-card-title">智能成长验证系统</div>
            <div class="feature-card-desc">
              每课时生成双维报告，家长实时追踪进度
            </div>
          </div>
        </div>
        <div class="feature-card">
          <div class="icon icon10"></div>
          <div class="feature-card-content">
            <div class="feature-card-title">国际化能力培养</div>
            <div class="feature-card-desc">
              虚拟场景训练提升跨文化交际与英语思维
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="progress-section">
      <div class="progress-title-small">学习效果</div>
      <div class="progress-title">让每一次进步都清晰可见</div>
      <div class="progress-inner">
        <div class="progress-img"></div>
        <div class="progress-info">
          <div class="progress-list">
            <div class="progress-list-item">
              <div class="lable-img icon11"></div>
              <div class="txt-box">
                <div class="txt1">科学验证的教学方法</div>
                <div class="txt2">千小时验证的"测→练→学→测→评"闭环系统</div>
              </div>
            </div>
            <div class="progress-list-item">
              <div class="lable-img icon12"></div>
              <div class="txt-box">
                <div class="txt1">可量化的进步轨迹</div>
                <div class="txt2">AI实时生成多维度成长曲线，进步清晰可见</div>
              </div>
            </div>
            <div class="progress-list-item">
              <div class="lable-img icon13"></div>
              <div class="txt-box">
                <div class="txt1">国际化能力培养</div>
                <div class="txt2">虚拟场景训练跨文化交际与英语思维</div>
              </div>
            </div>
            <div class="progress-list-item">
              <div class="lable-img icon14"></div>
              <div class="txt-box">
                <div class="txt1">家长可见的提升</div>
                <div class="txt2">直观呈现孩子的知识点与沟通力进展</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="level-section">
      <div class="level-title-small">独家体系</div>
      <div class="level-title">
        晓A精灵ATE九阶成长体系 <br />
        <span class="title1">Advanced in Teaching English</span>
      </div>
      <div class="level-img"></div>
      <!-- <el-table class="h-home-table" :data="tableData" style="width: 100%">
        <el-table-column prop="label1" label="阶段" width="50px">
          <template slot-scope="scope">
            <span class="txt1">{{ scope.row.label1 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="label2" label="年级" width="80px">
        </el-table-column>
        <el-table-column prop="label3" label="语言发展" width="80px">
        </el-table-column>
        <el-table-column prop="label4" label="素质培养" width="110px">
        </el-table-column>
        <el-table-column prop="label5" label="技能发展" width="150px">
        </el-table-column>
        <el-table-column prop="label6" label="学习重点"> </el-table-column>
        <el-table-column prop="label7" label="核心目标"> </el-table-column>
        <el-table-column prop="label8" label="欧洲标准" width="78px">
        </el-table-column>
        <el-table-column prop="label9" label="雅思测评" width="78px">
        </el-table-column>
        <el-table-column prop="label10" label="剑桥测评" width="95px">
        </el-table-column>
        <el-table-column prop="label11" label="托福测评" width="76px">
        </el-table-column>
        <el-table-column prop="label12" label="蓝思指数" width="110px">
        </el-table-column>
      </el-table> -->
    </div>
    <div class="features-section">
      <div class="features-cards">
        <div class="feature-card">
          <div class="icon icon15"></div>
          <div class="feature-card-content">
            <div class="feature-card-title">国际标准参考框架</div>
            <div class="feature-card-desc">
              从剑桥到雅思，从托福到欧标，从美国共同核心州立标准到蓝思阅读指数，学习成果国际认可
            </div>
          </div>
        </div>
        <div class="feature-card">
          <div class="icon icon16"></div>
          <div class="feature-card-content">
            <div class="feature-card-title">词汇量阶梯式增长</div>
            <div class="feature-card-desc">
              从600基础词汇到5500+学术词汇，科学规划每个级别的词汇掌握目标
            </div>
          </div>
        </div>
        <div class="feature-card">
          <div class="icon icon17"></div>
          <div class="feature-card-content">
            <div class="feature-card-title">能力递进式培养</div>
            <div class="feature-card-desc">
              从简单对话到跨文化辩论，逐步提升学生的综合语言应用能力
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="cta-section">
      <div class="cta-info">
        <div class="cta-title">准备好提升英语能力了吗？</div>
        <div class="cta-title">立即体验晓A精灵</div>
        <div class="cta-desc">
          让每个孩子既能在标准化考试中取得优异成绩，更能掌握面向未来的国际化语言能力。
        </div>
        <!-- <a class="cta-btn" href="#">免费试用</a> -->
        <div class="code"></div>
      </div>
      <div class="cta-img"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [
        {
          id: 1,
          label1: "L8",
          label2: "高三",
          label3: "综合突破",
          label4: "批判思维培养",
          label5: "高级讲座 跨文化辩论",
          label6: "处理文字 抽理理论",
          label7: "构建原创批评理论",
          label8: "C1-C2",
          label9: "7.0+",
          label10: "CAE/CPE",
          label11: "95+",
          label12: "1200L+",
        },
        {
          id: 2,
          label1: "L7",
          label2: "高二",
          label3: "综合突破",
          label4: "批判思维培养",
          label5: "论文研读 独文写作",
          label6: "分析目标表现点",
          label7: "掌握5500词",
          label8: "C1",
          label9: "6.5-7.0",
          label10: "CAE",
          label11: "80-95",
          label12: "1050L-1200L",
        },
        {
          id: 3,
          label1: "L6",
          label2: "高一",
          label3: "能力进阶",
          label4: "创新潜能激发",
          label5: "专业听力 演讲练习",
          label6: "分析事件结果",
          label7: "掌握5500词",
          label8: "B2-C1",
          label9: "5.5-6.5",
          label10: "FCE",
          label11: "60-80",
          label12: "900L-1050L",
        },
        {
          id: 4,
          label1: "L5",
          label2: "初二.初三",
          label3: "能力进阶",
          label4: "创新潜能激发",
          label5: "高级阅读 论文写作",
          label6: "解析表评价结果",
          label7: "掌握2500词",
          label8: "B2",
          label9: "5.0-5.5",
          label10: "PET",
          label11: "45-60",
          label12: "750L-900L",
        },
        {
          id: 5,
          label1: "L4",
          label2: "初一",
          label3: "基础巩固",
          label4: "沟通能力提升",
          label5: "学术听力 口语辩论",
          label6: "理解能力支持",
          label7: "掌握2500词",
          label8: "B1-B2",
          label9: "4.5-5.0",
          label10: "KET",
          label11: "35-45",
          label12: "600L-750L",
        },
        {
          id: 6,
          label1: "L3",
          label2: "小五.小六",
          label3: "基础巩固",
          label4: "沟通能力提升",
          label5: "阅读理解 写作练习",
          label6: "分析意图解决问题",
          label7: "撰写200词",
          label8: "A2-B1",
          label9: "4.0-4.5",
          label10: "MOVERS",
          label11: "25-35",
          label12: "500L-600L",
        },
        {
          id: 7,
          label1: "L2",
          label2: "小三.小四",
          label3: "兴趣激发",
          label4: "文化视野拓展",
          label5: "分拼口音 表达观点",
          label6: "别文字理解语言",
          label7: "掌握2000词",
          label8: "A1-A2",
          label9: "3.5-4.0",
          label10: "STARTERS",
          label11: "15-25",
          label12: "400L-500L",
        },
        {
          id: 8,
          label1: "L1",
          label2: "小三.小四",
          label3: "兴趣激发",
          label4: "文化视野拓展",
          label5: "简单对话 独文写作",
          label6: "识别观点 医行文字",
          label7: "掌握600词",
          label8: "PRE-A1",
          label9: "3.0-3.5",
          label10: "PRE-A1",
          label11: "10-15",
          label12: "300L-400L",
        },
      ],
    };
  },
};
</script>
<style lang="scss">
#home {
  .h-el-carousel {
    min-width: 1200px;
    width: 100%;
    height: 35vw;
    min-height: 520px;
    .el-carousel__container {
      height: 100% !important;
    }
    .h-el-carousel-img {
      width: 100%;
      height: 100%;
    }
  }
}
.h-home-table {
  .txt1 {
    font-weight: 600;
    color: #1d4ed8;
  }
  .el-table__header-wrapper {
    .el-table__header {
      th {
        font-size: 14px;
      }
    }
  }
  .el-table__body-wrapper {
    .el-table__body {
      .el-table__row {
        font-size: 14px;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.feature-card {
  cursor: pointer;
  &:hover {
    transform: scale(1.02);
  }
}
#home {
  color: #9a212a;
  padding-top: 60px;
  padding-bottom: 100px;
  background: #ffffff;

  .hero-bg {
    background: #f4d9d7;
  }
  .hero {
    width: 1200px;
    margin: 0 auto;
    padding: 60px 0 60px 0;
    text-align: center;
    .hero-title {
      font-size: 38px;
      font-weight: bold;
      line-height: 1;
      margin-bottom: 12px;
    }
    .blue {
      color: #9a212a;
    }
    .hero-desc {
      color: #9a212a;
      font-size: 16px;
      margin-bottom: 8px;
    }
  }

  .stats-section {
    width: 1200px;
    margin: 0 auto;
    margin-top: 32px;
    .stats-title-small {
      color: #9a212a;
      text-align: center;
      font-size: 14px;
      font-weight: bold;
      margin-bottom: 5px;
    }
    .stats-title {
      text-align: center;
      font-size: 30px;
      font-weight: bold;
      margin-bottom: 24px;
    }
    .stats-cards {
      display: flex;
      justify-content: center;
      gap: 32px;
    }
    .stat-card {
      flex: 1;
      // background: #fff;
      // border-radius: 12px;
      // box-shadow: 0 2px 8px #e5eaf3;
      padding: 0px 0 32px;
      text-align: center;
      min-width: 200px;
      .icon {
        width: 50px;
        height: 50px;
        margin: 0 auto 12px auto;
      }
      .icon1 {
        background-image: url(../assets/new-page/hone/icon1.png);
        background-size: 100% 100%;
      }
      .icon2 {
        background-image: url(../assets/new-page/hone/icon2.png);
        background-size: 100% 100%;
      }
      .icon3 {
        background-image: url(../assets/new-page/hone/icon3.png);
        background-size: 100% 100%;
      }
      .icon4 {
        background-image: url(../assets/new-page/hone/icon4.png);
        background-size: 100% 100%;
      }
      .stat-card-title {
        font-size: 16px;
        color: #9a212a;
        margin-bottom: 8px;
      }
      .stat-card-value {
        font-size: 28px;
        color: #9a212a;
        font-weight: bold;
      }
    }
  }
  .section-title-small {
    margin-top: 80px;
    color: #4f46e5;
    text-align: center;
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 5px;
  }
  .section-title {
    text-align: center;
    font-size: 30px;
    font-weight: bold;
    margin: 0 0 32px 0;
  }
  .compare-cards {
    display: flex;
    justify-content: center;
    gap: 32px;
    width: 1200px;
    margin: 0 auto;
    .compare-card {
      flex: 1;
      background: #fff;
      border-radius: 8px;
      // box-shadow: 0 2px 8px #e5eaf3;
      border: 1px solid #e5e7eb;
      padding: 32px 18px;
      min-width: 260px;
      .compare-card-title {
        padding-left: 18px;
        font-size: 17px;
        margin-bottom: 12px;
      }
      ul {
        padding-left: 18px;
        margin: 0;
        li {
          list-style-type: none;
          font-size: 15px;
          color: #9a212a;
          margin-bottom: 8px;
          .el-icon-close {
            font-weight: 600;
            color: #ef4444;
          }
        }
      }
    }
  }

  .ai-section {
    width: 1200px;
    margin: 40px auto;
    display: flex;
    align-items: center;
    // background: #f4f8ff;
    background: #f4d9d7;
    border-radius: 14px;
    padding: 32px 40px;
    box-sizing: border-box;
    .ai-info {
      .ai-info-title {
        color: #9a212a;
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 16px;
      }
      .ai-info-list {
        box-sizing: border-box;
        width: 570px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        font-size: 15px;
        color: #9a212a;
        line-height: 2;
        .ai-info-list-item {
          margin-top: 20px;
          width: 280px;
          display: flex;
          align-items: center;
          .ai-lable-img {
            margin-right: 10px;
            width: 50px;
            height: 50px;
          }
          .icon18 {
            background-image: url(../assets/new-page/hone/icon18.png);
            background-size: 100% 100%;
          }
          .icon19 {
            background-image: url(../assets/new-page/hone/icon19.png);
            background-size: 100% 100%;
          }
          .icon20 {
            background-image: url(../assets/new-page/hone/icon20.png);
            background-size: 100% 100%;
          }
          .icon21 {
            background-image: url(../assets/new-page/hone/icon21.png);
            background-size: 100% 100%;
          }
          .txt-box {
            .txt1 {
              font-size: 14px;
              color: #9a212a;
            }
            .txt2 {
              font-size: 12px;
              color: #9a212a;
            }
          }
        }
      }
    }
    .ai-img {
      width: 540px;
      height: 320px;
      // background: pink;
      // border-radius: 12px;
      margin-left: 40px;
      background-image: url(../assets/new-page/hone/img1.png);
      background-size: 100% 100%;
    }
  }

  .features-section {
    width: 1200px;
    margin: 0 auto;
    .features-title-small {
      margin-top: 80px;
      color: #9a212a;
      text-align: center;
      font-size: 14px;
      font-weight: bold;
      margin-bottom: 5px;
    }
    .features-title {
      text-align: center;
      font-size: 30px;
      font-weight: bold;
      margin-bottom: 32px;
    }
    .features-cards {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .feature-card {
        width: 340px;
        background: #f4d9d7;
        border-radius: 12px;
        padding: 32px 18px;
        margin-bottom: 34px;
        .icon {
          width: 50px;
          height: 50px;
          margin-bottom: 10px;
        }
        .icon5 {
          background-image: url(../assets/new-page/hone/icon5.png);
          background-size: 100% 100%;
        }
        .icon6 {
          background-image: url(../assets/new-page/hone/icon6.png);
          background-size: 100% 100%;
        }
        .icon7 {
          background-image: url(../assets/new-page/hone/icon7.png);
          background-size: 100% 100%;
        }
        .icon8 {
          background-image: url(../assets/new-page/hone/icon8.png);
          background-size: 100% 100%;
        }
        .icon9 {
          background-image: url(../assets/new-page/hone/icon9.png);
          background-size: 100% 100%;
        }
        .icon10 {
          background-image: url(../assets/new-page/hone/icon10.png);
          background-size: 100% 100%;
        }
        .icon15 {
          background-image: url(../assets/new-page/hone/icon15.png);
          background-size: 100% 100%;
        }
        .icon16 {
          background-image: url(../assets/new-page/hone/icon16.png);
          background-size: 100% 100%;
        }
        .icon17 {
          background-image: url(../assets/new-page/hone/icon17.png);
          background-size: 100% 100%;
        }
        .feature-card-content {
          flex: 1;
          .feature-card-title {
            font-size: 16px;
            font-weight: bold;
            margin-bottom: 8px;
          }
          .feature-card-desc {
            font-size: 15px;
            color: #9a212a;
          }
        }
      }
    }
  }

  .progress-section {
    width: 100%;
    background: #f4d9d7;
    margin: 40px 0;
    padding: 48px 0;
    .progress-title-small {
      color: #9a212a;
      text-align: center;
      font-size: 14px;
      font-weight: bold;
      margin-bottom: 5px;
    }
    .progress-title {
      text-align: center;
      font-size: 30px;
      font-weight: bold;
      margin-bottom: 32px;
    }
    .progress-inner {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      .progress-img {
        width: 600px;
        height: 380px;
        border-radius: 8px;
        margin-right: 100px;
        background-image: url(../assets/new-page/hone/img2.jpg);
        background-size: 100% 100%;
      }
      .progress-info {
        flex: 1;
        .progress-list {
          font-size: 15px;
          color: #9a212a;
          .progress-list-item {
            margin-bottom: 20px;
            display: flex;
            .lable-img {
              position: relative;
              top: -8px;
              left: 8px;
              margin-right: 18px;
              width: 50px;
              height: 50px;
            }
            .icon11 {
              background-image: url(../assets/new-page/hone/icon11.png);
              background-size: 100% 100%;
            }
            .icon12 {
              background-image: url(../assets/new-page/hone/icon12.png);
              background-size: 100% 100%;
            }
            .icon13 {
              background-image: url(../assets/new-page/hone/icon10.png);
              background-size: 100% 100%;
            }
            .icon14 {
              background-image: url(../assets/new-page/hone/icon14.png);
              background-size: 100% 100%;
            }
            .txt-box {
              .txt1 {
                margin-bottom: 10px;
                font-size: 16px;
                font-weight: bold;
              }
              .txt2 {
                font-size: 15px;
                color: #9a212a;
              }
            }
          }
        }
      }
    }
  }

  .level-section {
    width: 1200px;
    margin: 0 auto;
    margin-bottom: 70px;
    .level-title-small {
      margin-top: 80px;
      color: #9a212a;
      text-align: center;
      font-size: 14px;
      font-weight: bold;
      margin-bottom: 5px;
    }
    .level-title {
      text-align: center;
      font-size: 28px;
      font-weight: bold;
      margin-bottom: 32px;
      .title1 {
        font-size: 18px;
      }
    }
    .level-img {
      width: 100%;
      height: 800px;
      background-image: url(../assets/new-page/hone/img4.png);
      background-size: 100% 100%;
    }
  }

  .cta-section {
    box-sizing: border-box;
    width: 1200px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    // background: #1d4ed8;
    background: #9a212a;
    border-radius: 14px;

    color: #fff;
    .cta-info {
      width: 600px;
      padding: 32px 80px;
      flex: 1;
      .cta-title {
        line-height: 1;
        font-size: 36px;
        font-weight: bold;
      }
      .cta-desc {
        color: #ccc;
        font-size: 18px;
        margin-top: 10px;
        margin-bottom: 20px;
      }
      .code {
        border-radius: 4px;
        width: 100px;
        height: 100px;
        background-image: url(../assets/new-page/hone/code.jpg);
        background-size: 100% 100%;
      }
      .cta-btn {
        display: inline-block;
        background: #fff;
        color: #9a212a;
        padding: 10px 30px;
        border-radius: 5px;
        font-size: 16px;
        text-decoration: none;
        font-weight: bold;
      }
    }
    .cta-img {
      width: 600px;
      height: 390px;
      border-radius: 10px;
      background-image: url(../assets/new-page/hone/img3.jpg);
      background-size: 100% 100%;
    }
  }
}
</style>
